/**
 * Swypy Theme JS
 * Core functionality
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initMobileNav();
    initAccordions();
    initQuantitySelectors();
    initDeliveryEstimate();
  });

  // Mobile navigation
  function initMobileNav() {
    var menuToggle = document.querySelector('.header__menu-toggle');
    var mobileNav = document.querySelector('.mobile-nav');
    var mobileNavClose = document.querySelector('.mobile-nav__close');
    var overlay = document.querySelector('.mobile-nav__overlay');

    function openNav() {
      if (mobileNav) mobileNav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      if (mobileNav) mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      if (mobileNav) mobileNav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      if (mobileNav) mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (menuToggle) menuToggle.addEventListener('click', openNav);
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);

    // Close on escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  // Accordions
  function initAccordions() {
    document.querySelectorAll('.accordion__button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        var content = btn.nextElementSibling;
        if (content) content.classList.toggle('is-open');
      });
    });
  }

  // Quantity selectors
  function initQuantitySelectors() {
    document.querySelectorAll('.quantity__button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.quantity__input');
        if (!input) return;

        var val = parseInt(input.value) || 0;
        var min = parseInt(input.min) || 0;
        var max = parseInt(input.max) || 9999;

        if (btn.dataset.action === 'increase' && val < max) {
          input.value = val + 1;
        } else if (btn.dataset.action === 'decrease' && val > min) {
          input.value = val - 1;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // Delivery estimate - Spanish month names, format "21 de agosto"
  function initDeliveryEstimate() {
    var startEl = document.getElementById('delivery-date-start');
    var endEl = document.getElementById('delivery-date-end');

    if (!startEl || !endEl) return;

    var monthNames = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    function formatSpanishDate(date) {
      var day = date.getDate();
      var month = monthNames[date.getMonth()];
      return day + ' de ' + month;
    }

    var now = new Date();

    // Start date: today + 5 days
    var startDate = new Date(now);
    startDate.setDate(startDate.getDate() + 5);

    // End date: today + 7 days
    var endDate = new Date(now);
    endDate.setDate(endDate.getDate() + 7);

    startEl.textContent = formatSpanishDate(startDate);
    endEl.textContent = formatSpanishDate(endDate);
  }

  // Expose utilities
  window.Swypy = window.Swypy || {};

  // Format money
  window.Swypy.formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  // Add to cart
  window.Swypy.addToCart = function(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function(response) {
      return response.json();
    });
  };

  // Get cart
  window.Swypy.getCart = function() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    });
  };

  // ========================================================================
  // Cart Drawer Module
  // ========================================================================

  var CartDrawer = (function() {
    var drawer = null;
    var panel = null;
    var overlay = null;
    var emptyState = null;
    var itemsContainer = null;
    var subtotalEl = null;
    var footerEl = null;
    var isOpen = false;

    function init() {
      drawer = document.getElementById('cart-drawer');
      if (!drawer) return;

      panel = drawer.querySelector('.cart-drawer__panel');
      overlay = drawer.querySelector('.cart-drawer__overlay');
      emptyState = drawer.querySelector('[data-cart-drawer-empty]');
      itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
      subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
      footerEl = drawer.querySelector('[data-cart-drawer-footer]');

      // Close buttons and overlay
      drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function(el) {
        el.addEventListener('click', close);
      });

      // Toggle button (cart icon in header)
      document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          open();
        });
      });

      // ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen) {
          close();
        }
      });

      // Intercept product form submissions
      interceptFormSubmissions();
    }

    function open() {
      if (!drawer) return;
      isOpen = true;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Focus the panel
      if (panel) panel.focus();

      // Fetch and render cart
      renderCart();
    }

    function close() {
      if (!drawer) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderCart() {
      window.Swypy.getCart().then(function(cart) {
        updateHeaderCount(cart.item_count);

        if (cart.item_count === 0) {
          showEmptyState();
        } else {
          showItems(cart);
        }
      });
    }

    function showEmptyState() {
      if (emptyState) emptyState.hidden = false;
      if (itemsContainer) itemsContainer.hidden = true;
      if (footerEl) footerEl.hidden = true;
    }

    function showItems(cart) {
      if (emptyState) emptyState.hidden = true;
      if (itemsContainer) itemsContainer.hidden = false;
      if (footerEl) footerEl.hidden = false;

      // Render items
      var html = '';
      cart.items.forEach(function(item, index) {
        html += renderItem(item, index + 1);
      });
      if (itemsContainer) itemsContainer.innerHTML = html;

      // Update subtotal
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      // Bind quantity buttons
      bindItemControls();
    }

    function renderItem(item, line) {
      var imageUrl = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var sellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
      var isGift = item.final_line_price === 0;

      var controls = isGift
        ? '<span class="cart-drawer-item__gift-note">Incluido con tu pedido</span>' +
          '<span class="cart-drawer-item__price cart-drawer-item__price--gift">GRATIS</span>'
        : '<div class="cart-drawer-item__quantity">' +
            '<button type="button" class="cart-drawer-item__qty-btn" data-action="decrease" aria-label="Disminuir">-</button>' +
            '<span class="cart-drawer-item__qty-value">' + item.quantity + '</span>' +
            '<button type="button" class="cart-drawer-item__qty-btn" data-action="increase" aria-label="Aumentar">+</button>' +
          '</div>' +
          '<span class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>';

      return '<div class="cart-drawer-item' + (isGift ? ' cart-drawer-item--gift' : '') + '" data-line="' + line + '">' +
        '<div class="cart-drawer-item__image">' +
          (imageUrl ? '<img src="' + imageUrl + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="cart-drawer-item__details">' +
          (isGift ? '<span class="cart-drawer-item__gift-badge">\uD83C\uDF81 REGALO</span>' : '') +
          '<p class="cart-drawer-item__title">' + escapeHtml(item.product_title) + '</p>' +
          (variantTitle ? '<p class="cart-drawer-item__variant">' + escapeHtml(variantTitle) + '</p>' : '') +
          '<div class="cart-drawer-item__bottom">' + controls + '</div>' +
          '<button type="button" class="cart-drawer-item__remove" data-action="remove">Eliminar</button>' +
        '</div>' +
      '</div>';
    }

    function bindItemControls() {
      if (!itemsContainer) return;

      itemsContainer.querySelectorAll('.cart-drawer-item').forEach(function(itemEl) {
        var line = parseInt(itemEl.dataset.line);
        var qtyValue = itemEl.querySelector('.cart-drawer-item__qty-value');
        var decBtn = itemEl.querySelector('[data-action="decrease"]');
        var incBtn = itemEl.querySelector('[data-action="increase"]');
        var remBtn = itemEl.querySelector('[data-action="remove"]');
        var currentQty = qtyValue ? parseInt(qtyValue.textContent) : 1;

        if (decBtn) decBtn.addEventListener('click', function() {
          var newQty = currentQty - 1;
          if (newQty < 1) newQty = 0; // 0 removes the item
          updateQuantity(line, newQty);
        });

        if (incBtn) incBtn.addEventListener('click', function() {
          updateQuantity(line, currentQty + 1);
        });

        if (remBtn) remBtn.addEventListener('click', function() {
          updateQuantity(line, 0);
        });
      });
    }

    function updateQuantity(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        updateHeaderCount(cart.item_count);
        if (cart.item_count === 0) {
          showEmptyState();
        } else {
          showItems(cart);
        }
      });
    }

    function updateHeaderCount(count) {
      var countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) {
        el.textContent = count;
        el.dataset.cartCount = count;
      });
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = parseInt(cents.replace('.', ''));
      }
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function interceptFormSubmissions() {
      document.addEventListener('submit', function(e) {
        var form = e.target;
        if (!form.action || form.action.indexOf('/cart/add') === -1) return;

        // Check if already being handled by product-bundles.js upsell
        if (form.dataset.drawerHandled) return;

        e.preventDefault();
        form.dataset.drawerHandled = 'true';

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function() {
          delete form.dataset.drawerHandled;
          open();
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
          delete form.dataset.drawerHandled;
        });
      });
    }

    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', init);

    return {
      open: open,
      close: close,
      render: renderCart
    };
  })();

  // Expose cart drawer
  window.Swypy.CartDrawer = CartDrawer;
  window.openCartDrawer = function() { CartDrawer.open(); };
  window.closeCartDrawer = function() { CartDrawer.close(); };

})();
